export const FinancialTypes = {
  IFinancialService: Symbol("IFinancialService"),
};
